<div class="game-timeline-filters" *ngIf="game.status === gameStatuses.closed">
  <a
    [ngClass]="{active: !selectedPeriod}"
    (click)="selectedPeriod = null"
  >Все
  </a>
  <a
    *ngFor="let set of sets"
    [ngClass]="{active: selectedPeriod === set}"
    (click)="selectedPeriod = set"
  >{{ set }} сет
  </a>

  <div class="right-filters">
    <a
      [ngClass]="{active: onlyHighlights}"
      class="fiba-btn"
      (click)="toggleOnlyHighlights()"
    >Highlights
    </a>
    <a
      [ngClass]="{active: onlyScoreLogs}"
      class="fiba-btn"
      (click)="toggleOnlyScoreLogs()"
    >Только очки
    </a>
  </div>
</div>
<div class="game-timeline">
  <div class="heading" *ngIf="game.status === gameStatuses.closed && !selectedPeriod && sort === 'desc'">
    Игра завершена
    (
    <div class="score">{{ game.teamScore }} : {{ game.competitorTeamScore }}</div>
    )
  </div>
  <ng-container
    *ngFor="let item of gameLogs; trackBy: identify; let i=index"
  >
    <ng-container
      *ngIf="!selectedPeriod || selectedPeriod === item.set"
    >
      <div class="heading" *ngIf="sort === 'asc' && isSetHeadingVisible(item, gameLogs[i - 1])">
        {{ item.set }} сет
        (
        <div class="score" *ngIf="item.set > 1 && scoreBySet">{{ scoreBySet[item.set - 1][0] }}
          : {{ scoreBySet[item.set - 1][1] }}</div>
        <div class="score" *ngIf="item.set === 1">0 : 0</div>
        )
      </div>
      <div class="rally" *ngIf="sort === 'desc' && isRallyScoreVisible(item, gameLogs[i - 1])">
        <div class="score">
          {{ scoresByRally[item.set][item.rally][0] }} : {{ scoresByRally[item.set][item.rally][1] }}
        </div>
      </div>
      <mtg-volleyball-game-timeline-item
        *ngIf="(!onlyScoreLogs || item.isScoreType() || item.isFaultType()) && (!onlyHighlights || item.isHighlight)"
        [game]="game"
        [gameLog]="item"
        [gameUsers]="gameUsers"
        [reverse]="reverse"
        class="timeline-item"
      ></mtg-volleyball-game-timeline-item>
      <div class="rally" *ngIf="sort === 'asc' && isRallyScoreVisible(item, gameLogs[i + 1]) && item.rally > 0">
        <div class="score">
          {{ scoresByRally[item.set][item.rally][0] }} : {{ scoresByRally[item.set][item.rally][1] }}
        </div>
      </div>
      <div class="heading" *ngIf="sort === 'desc' && isSetHeadingVisible(item, gameLogs[i + 1])">
        {{ item.set }} сет
        (
        <div class="score" *ngIf="item.set > 1 && scoreBySet">{{ scoreBySet[item.set - 1][0] }}
          : {{ scoreBySet[item.set - 1][1] }}</div>
        <div class="score" *ngIf="item.set === 1">0 : 0</div>
        )
      </div>
    </ng-container>
  </ng-container>
  <!--  <ng-container *ngIf="sort == 'desc' && isRallyScoreVisible(lastLog, null)">-->
  <!--    <div class="rally">-->
  <!--      <div class="score">{{ scoresByRally[lastLog.set][lastLog.rally][0] }} : {{ scoresByRally[lastLog.set][lastLog.rally][1] }}</div>-->
  <!--    </div>-->
  <!--  </ng-container>-->
  <div class="heading" *ngIf="game.status === gameStatuses.closed && !selectedPeriod && sort === 'asc'">
    Игра завершена
    (
    <div class="score">{{ game.teamScore }} : {{ game.competitorTeamScore }}</div>
    )
  </div>
</div>
